export default __webpack_public_path__ + "static/media/hht1_ani_04.7c50b9a5.png";